import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M20 18l2-2V4H2v12l2 2H0v2h24v-2h-4zM4 6h16v10H4V6z"
}), 'ComputerSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ComputerSharp.js
// module id = 2916
// module chunks = 2